"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = _interopRequireDefault(require("./user"));
var _customer = _interopRequireDefault(require("./customer"));
var _cookies = _interopRequireDefault(require("./cookies"));
/**
 * Delegate details
 *
 * @Constructor Delegate
 * @param {Object} options Optional configuration.
 * @api public
 */
class Delegate extends _user.default {
  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  updateFromCookie() {
    this.cookies.updateIdp();
    const del = this.cookies.getIdpProperty('del');
    const delType = del && del.auth;
    if (delType && delType !== 'basic') {
      // In more complex impersonation scenarios such as e2s2s, we need to dig another layer deeper to get information
      // about the middle customer in a two-layer impersonation/delegation stack. So we store that Customer here and
      // then load their info directly from the parsed `del` section of the cookie.
      this.impersonatedCustomer = new _customer.default();
      const customerInfo = this.impersonatedCustomer.getIdpProperties((properties, replace) => {
        return _cookies.default.getRealmPropertiesFromObject(del, properties, replace);
      }, delType);
      this.impersonatedCustomer.set(customerInfo);
    }
    this.set(this.cookies.getIdpProperties(['firstname', 'lastname', 'info_accountname', 'jti'].map(property => ['del', delType === 'basic' ? null : 'del', property].filter(Boolean)), {
      info_accountname: 'accountName'
    }));
  }
}
exports.default = Delegate;